import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">This tool can help</div>
                                            <p>The halo effect is one of many different influences that can
                                                shape the way we get to know and understand other people. There
                                                are a number of techniques that can be adopted to help us
                                                develop stronger rapport and avoid making swift but irrational
                                                judgements. This tool is about<span className="brown brownbold"> how to develop rapport </span>and
                                                will help you understand how to do it successfully.</p>

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">THE IMPORTANCE OF RAPPORT</span>
                                            </div>
                                            <p>Why do some people seem able to talk to anyone and others just
                                                stand about, all buttoned up? Is it that some of us are
                                                naturally more gregarious or can you learn how to find and build
                                                a rapport with whoever you need to get on with, say, at
                                                work?</p>
                                            <p>It’s not about instant likes or dislikes or recognising ‘your own
                                                kind’ of person. Building rapport, with anyone, is knowing how
                                                to establish a mutual connection, a warmth which may then enable
                                                a degree of trust.</p>
                                            <p>Similar to empathy, rapport helps us communicate acceptance or
                                                understanding of another. Although it comes more easily to some
                                                than others, we’re all able to develop rapport, but we may need
                                                to know how, particularly in situations where you need something
                                                such as support or advice. The three practical exercises to help
                                                build rapport in this tool concern body language, verbal
                                                communication and how you reveal your personality and
                                                credibility to establish common ground.</p>


                                            <div
                                                className="lightgreencontentbg lightbgcontentShrink keyquestionpad2">
                                                <div className="border_subtitle">What are the outcomes?</div>
                                                <p>Building rapport means that you’re more likely to gain the
                                                    best possible outcomes from meetings and interactions with
                                                    others. In a business environment, the ability to build
                                                    rapport facilitates telephone calls, face-to-face meetings,
                                                    presentations and relationships with colleagues and
                                                    clients.</p>
                                                <p>As a manager, flexing your style to build rapport with the
                                                    individuals in your team and clients involves taking the
                                                    lead and making an effort to create a climate that
                                                    facilitates better performance management, training and
                                                    delivery.</p>
                                                <p>Building rapport is about creating an emotional environment
                                                    which allows genuine communication. Then, connections are
                                                    made, ideas are developed and productive working
                                                    relationships are formed.</p>
                                                <p>Below we outline a three-factor model of the process of
                                                    building rapport.</p>
                                            </div>
                                            <br/>
                                                <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                    <span
                                                        className="heading">3 - FACTOR MODEL OF BUILDING RAPPORT</span>
                                                </div>
                                                <div className="paraspace"><p>A landmark study on rapport by
                                                    Albert Mehrabian<a className="superscripttext"
                                                                       href="further_info.php?course=300"><sup>3</sup></a> measured
                                                    the impact of voice tone and body language on our
                                                    perceptions of the trustworthiness of other people. The
                                                    researchers found that when people smiled warmly whilst
                                                    saying ‘I don’t like you’ the other person was unlikely to
                                                    believe what they said. Body language overruled the actual
                                                    meaning of the words. More specifically they found that:</p>
                                                </div>
                                                <ul className="greenbullet-list ">

                                                    <li>55% of the impression you make comes from your behaviour
                                                        and your body language.
                                                    </li>
                                                    <li>38% of the impression you make comes from your tone of
                                                        voice.
                                                    </li>
                                                    <li className="list-bottom-pad">7% of the impression you
                                                        make comes from the actual words you say.
                                                    </li>

                                                </ul>
                                                <p>Based on the findings of this study, and our work in
                                                    coaching, there are three key elements of building rapport –
                                                    creating common ground, body language and verbal
                                                    communication.</p>
                                                <div className="left-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page1')}
                                                        className="button-next-previous-done">&lt;&lt; Previous
                                                    </div>
                                                </div>
                                                <div className="right-btn">
                                                    <div
                                                        onClick={this.props.handleChangePage('Page3')}
                                                        className="button-next-previous-done">Next &gt;&gt;</div>
                                                </div>


                                        </div>


                                    </div>


                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }